import { useEffect } from 'react';

/** Adds `classNames` to the page's `<body>` while `active` (e.g. a drag cursor), removing them when it ends or unmounts. */
export function useBodyClasses(classNames: readonly string[], active: boolean): void {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;
    const { body } = document;
    body.classList.add(...classNames);
    return () => body.classList.remove(...classNames);
  }, [classNames, active]);
}
